const n = "_suffix_rxyjg_1", s = "_readOnly_rxyjg_8", t = "_input_rxyjg_12", _ = {
  suffix: n,
  readOnly: s,
  input: t
};
export {
  _ as default,
  t as input,
  s as readOnly,
  n as suffix
};
//# sourceMappingURL=style.module.scss.js.map
